import { ComponentType } from 'react';
import { components as ReactSelectComponents } from 'react-select';
import { TagComponents, UserComponents } from 'components/atoms/select';
import { VirtualizedMenuList } from 'components/atoms/select/custom-components';
import {
  TagTriggerOption,
  TriggerOptionProps,
  UserTriggerOption,
} from 'components/organisms/field-editors/components/controlled-select-based-editor-trigger-content';

export type EditorComponents = Partial<typeof ReactSelectComponents> & {
  TriggerOption: ComponentType<TriggerOptionProps>;
};

export const UserEditorComponents = {
  ...UserComponents,
  TriggerOption: UserTriggerOption,
};
export const CreatedByEditorComponent = {
  ...UserEditorComponents,
  MenuList: VirtualizedMenuList,
};
export const TagEditorComponents = {
  ...TagComponents,
  TriggerOption: TagTriggerOption,
};
